export const AUTO_SUBGROUP_SKIP_COST = [192, 209, 210];
export const PERCENT_IMPORT_SUBGRUPOS = new Set([192, 209, 210]);

export function isBudgetLineComplete(line) {
  const parsedUn = parseFloat(line?.Un);
  return (
    !Number.isNaN(parsedUn) &&
    parsedUn > 0 &&
    parseFloat(line?.Coste) > 0 &&
    Boolean(line?.MonedaCoste) &&
    Boolean(line?.MonedaVenta) &&
    parseFloat(line?.CosteConvertido) > 0
  );
}

export function shouldSkipAutoSubgroupCostCalc(line, forceRecalc = false) {
  if (forceRecalc) return false;
  return (
    AUTO_SUBGROUP_SKIP_COST.includes(Number(line?.ESCANDALLO_SUBGRUPO)) &&
    Number(line?.ESCANDALLO_GRUPOS) === 13 &&
    Number(line?.CosteConvertido) > 0
  );
}

export function computeCosteConvertido({
  coste,
  un,
  tipoCambio,
  dividirPorCien = false,
}) {
  const c = Number(coste);
  const u = Number(un);
  const tc = Number(tipoCambio);
  if (!Number.isFinite(c) || !Number.isFinite(u) || !Number.isFinite(tc)) return 0;
  if (c <= 0 || u <= 0) return 0;
  return parseFloat(((c * u * tc) / (dividirPorCien ? 100 : 1)).toFixed(2));
}

export function applyBudgetLinePricing(line, triggerField = null) {
  const updatedLine = { ...line };
  updatedLine.MargenVenta = updatedLine.MargenVenta ?? 10;
  updatedLine.CosteConvertido = parseFloat(
    (updatedLine.CosteConvertido || 0).toFixed(2),
  );

  if (updatedLine.CosteConvertido <= 0) return updatedLine;

  const convCost = parseFloat(updatedLine.CosteConvertido) || 0;
  const marginPct = parseFloat(updatedLine.MargenVenta);
  const saleValue = parseFloat(updatedLine.Venta);
  const marginValue = parseFloat(updatedLine.MargenCoste);

  if (triggerField === "Venta") {
    const venta = !Number.isNaN(saleValue) && saleValue > 0 ? saleValue : 0;
    const derivedPct =
      venta > 0 ? ((venta - convCost) / venta) * 100 : marginPct || 0;
    updatedLine.Venta = venta;
    updatedLine.MargenVenta = parseFloat(derivedPct.toFixed(2));
  } else if (triggerField === "MargenCoste") {
    const margenImporte = !Number.isNaN(marginValue) ? marginValue : 0;
    const venta = convCost + margenImporte;
    const derivedPct = venta > 0 ? (margenImporte / venta) * 100 : 0;
    updatedLine.Venta = venta;
    updatedLine.MargenVenta = parseFloat(derivedPct.toFixed(2));
    updatedLine.MargenCoste = margenImporte;
  } else {
    const margen = !Number.isNaN(marginPct) ? marginPct : 10;
    const denominator = 1 - margen / 100;
    updatedLine.Venta =
      denominator !== 0
        ? parseFloat((convCost / denominator).toFixed(2))
        : 0;
    updatedLine.MargenVenta = parseFloat(margen.toFixed(2));
  }

  if (triggerField !== "MargenCoste") {
    updatedLine.MargenCoste = parseFloat(
      ((updatedLine.Venta || 0) - convCost).toFixed(2),
    );
  }

  return updatedLine;
}

/** Valores numéricos a medio teclear (p. ej. "28." / "28,") que no deben forzar recálculo. */
export function isTransientDecimalInput(value) {
  if (typeof value !== "string") return false;
  const v = String(value).trim().replace(",", ".");
  return (
    v === "" ||
    v === "-" ||
    v === "." ||
    v === "-." ||
    /^-?\d+\.$/.test(v)
  );
}

/** Normaliza separador decimal y valida input numérico parcial. */
export function normalizeDecimalTyping(raw) {
  const normalized = String(raw ?? "").replace(",", ".");
  if (
    normalized === "" ||
    normalized === "-" ||
    /^-?\d*\.?\d*$/.test(normalized)
  ) {
    return normalized;
  }
  return null;
}
